import { FaServer, FaDocker, FaAws, FaCode } from "react-icons/fa";
import { SiKubernetes, SiGithubactions } from "react-icons/si";

// Features Data — aligned with Biprodas Barai's actual CV
export const featuresData = [
  {
    id: 1,
    icon: <FaServer />,
    title: "Backend Engineering",
    des: "2+ years building production-grade REST APIs and microservices. Expert in Node.js, TypeScript, NestJS, and Express.js. Designed and shipped four production systems handling pricing automation, warehouse management, and marketplace integrations at scale.",
  },
  {
    id: 2,
    icon: <FaDocker />,
    title: "Containerization & Orchestration",
    des: "Deep hands-on experience with Docker and Kubernetes. Provisioned multi-node K8s clusters using kubeadm on AWS EC2, deployed microservices via Helm charts and Ingress controllers, and managed workloads on AWS EKS.",
  },
  {
    id: 3,
    icon: <SiGithubactions />,
    title: "CI/CD & DevSecOps",
    des: "Designed end-to-end CI/CD pipelines with GitHub Actions and Jenkins. Integrated Trivy, OWASP Dependency Check, and SonarQube as automated security gates. Implemented Blue-Green zero-downtime deployments — push to main goes live in under 5 minutes.",
  },
  {
    id: 4,
    icon: <FaAws />,
    title: "Cloud Infrastructure (AWS)",
    des: "Deployed and operated production services on AWS using EC2, EKS, S3, Route53, ACM, and NGINX reverse proxy with SSL/TLS. Managed full cloud lifecycle from provisioning to monitoring with Prometheus and Grafana.",
  },
  {
    id: 5,
    icon: <FaCode />,
    title: "Marketplace API Integrations",
    des: "Built multi-platform connectors for Amazon SP-API, Amazon Ads, Walmart, TikTok Shop, Temu, Shopify, and Etsy — including OAuth2 token lifecycle management, rate-limit handling, and automated pricing engines.",
  },
  {
    id: 6,
    icon: <SiKubernetes />,
    title: "Infrastructure as Code",
    des: "Hands-on experience with Terraform and Ansible for infrastructure automation. Built reproducible, version-controlled infrastructure deployments. Comfortable with full backend-to-infrastructure ownership on production systems.",
  },
];